export const localConfig = {
  REACT_APP_AZURE_CLIENT_ID: '1f0d4405-aa31-4ed2-a1fa-0d07e4a628d9',
  REACT_APP_API_URL: 'https://as-mg-dev1-t1-weu-smartinsights-api-01.azurewebsites.net',
  REACT_APP_AZURE_REDIRECT_URL: 'http://localhost:3000',
  REACT_APP_AZURE_AUTHORITY:
    'https://login.microsoftonline.com/aa42167d-6f8d-45ce-b655-d245ef97da66',
  REACT_APP_AZURE_SCOPE: 'api://c664fc18-d240-463e-ac88-3b9690fce210/User.Read',
  APP_INSIGHTS_CONNECTION_STR:
    'InstrumentationKey=f5de0f0c-0845-4f13-8bfe-4f0b61429f5e;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=fe917f39-a614-446b-9777-a771522e4c64'
}

export const getConfig = () => {
  if (import.meta.env.MODE === 'development') {
    return localConfig
  } else {
    return window.config
  }
}
